import { CloseButton } from "@commerce-frontend/ui/base/CloseButton/CloseButton";
import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import { DialogClose } from "@commerce-frontend/ui/components/Dialog/Dialog";
import { cn } from "@commerce-frontend/ui/utils/classNames";
import type { ReactElement } from "react";
import React from "react";

type Props = {
	onBack?: () => void;
	title?: string;
	children?: React.ReactNode;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TopBar = ({ onBack, title, children }: Props): ReactElement<any> => (
	<div className="flex items-center border-b border-border">
		<div className="flex flex-1 justify-start">
			{onBack && (
				<button
					className="flex size-14 items-center justify-center"
					onClick={onBack}
				>
					<Icon icon="chevron-left" className="size-6 bg-main" />
					<span className="sr-only">Back</span>
				</button>
			)}
		</div>

		<div className={cn(children && "w-full")}>
			<strong className="text-lg text-main">{title}</strong>
			{children}
		</div>

		<DialogClose asChild>
			<div className="flex flex-1 justify-end">
				<CloseButton
					classes={{
						button: "flex size-14 items-center justify-center",
					}}
					variant="info"
				>
					<span className="sr-only">Close</span>
				</CloseButton>
			</div>
		</DialogClose>
	</div>
);

export default TopBar;
